const screenSize = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  '2XL': 1536,
}

const mediaQuery = Object.entries(screenSize).reduce(
  (queries, [token, size]) => {
    return {
      ...queries,
      [token]: `(min-width: ${size}px)`,
    }
  },
  {},
)

export { screenSize, mediaQuery }
